"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventExampleIn = void 0;
class EventExampleIn {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventExampleIn.attributeTypeMap;
    }
}
exports.EventExampleIn = EventExampleIn;
EventExampleIn.discriminator = undefined;
EventExampleIn.attributeTypeMap = [
    {
        "name": "eventType",
        "baseName": "eventType",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=EventExampleIn.js.map